import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChatRoomType } from 'enums/modules/chat/chatRoomType';

export interface SelectedWidgetChat {
  id: ID;
  type: ChatRoomType;
  name: string | null;
}

export interface WidgetChatState {
  selectedChat: SelectedWidgetChat | null;
  isOpened: boolean;
}

const initialState: WidgetChatState = {
  selectedChat: null,
  isOpened: false,
};

export const widgetChatSlice = createSlice({
  name: 'selectedChat',
  initialState,
  reducers: {
    setChat: (state, action: PayloadAction<SelectedWidgetChat | null>) => {
      state.selectedChat = action.payload;
    },
    open: (
      state,
      action: PayloadAction<SelectedWidgetChat | null | undefined>
    ) => {
      state.isOpened = true;
      if (typeof action.payload !== 'undefined') {
        state.selectedChat = action.payload;
      }
    },
    close: (state) => {
      state.isOpened = false;
    },
    toggle: (state) => {
      state.isOpened = !state.isOpened;
    },
  },
});
